var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGuest = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 18"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 5,
  r: 3.5,
  stroke: "#3E4E5D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E4E5D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.5,
  d: "M4.984 3.223a5.81 5.81 0 0 0 6.483 1.303M1.5 16.5a6.5 6.5 0 1 1 13 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E4E5D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.5,
  d: "M5.5 10.5v.5a2.5 2.5 0 0 0 5 0v-.5"
})));
export default SvgGuest;